module.exports = {"CurrentLanguage":"en"}


//////////////////
// WEBPACK FOOTER
// ./src/languages/en.json
// module id = bczw
// module chunks = 1